import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ onOpenContactModal }) => (
  <footer className="relative z-10 border-t border-[var(--color-border)] bg-[var(--color-surface-muted)] py-3 sm:py-4 mt-auto">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="flex flex-col sm:flex-row justify-between items-center text-xs sm:text-sm text-[var(--color-text-muted)] space-y-2 sm:space-y-0">
        <p>© {new Date().getFullYear()} DocxsAi. All rights reserved.</p>
        <div className="flex space-x-6 sm:space-x-10">
          <Link to="/privacy" className="hover:text-[var(--color-text)] transition-colors inline-flex items-center">Privacy</Link>
          <Link to="/terms" className="hover:text-[var(--color-text)] transition-colors inline-flex items-center">Terms</Link>
          {onOpenContactModal ? (
            <button
              className="hover:text-[var(--color-text)] transition-colors bg-transparent border-none outline-none cursor-pointer inline-flex items-center px-2"
              onClick={onOpenContactModal}
              type="button"
            >
              Contact
            </button>
          ) : (
            <a href="#contact" className="hover:text-[var(--color-text)] transition-colors inline-flex items-center px-2">Contact</a>
          )}
        </div>
      </div>
    </div>
  </footer>
);

export default Footer; 